import {Component, inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatOption, MatSelect} from '@angular/material/select';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../shared/shared.module';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {KtTripsFilterService} from '../../service/kt-trips-filter.service';
import {KtTripFilterModel} from '../../models/kt-filter.model';

@Component({
  selector: 'app-kt-trips-filter-modal',
  imports: [
    MatButton,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatHint,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatSuffix,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './kt-trips-filter-modal.component.html',
  styles: [`
    .filter__fields {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
    }
    .filter__fields.two-col {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 8px 20px;
    }
    mat-form-field {
      width: 100%;
      min-width: 0;
    }
  `],
})
export class KtTripsFilterModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<KtTripsFilterModalComponent>);
  private readonly filterService = inject(KtTripsFilterService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly form = this.filterService.form;
  protected isSmall = false;

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  public ngOnInit(): void {
    this.patchForm();
  }

  private patchForm(): void {
    const f = this.filterService.filtersValue();
    this.form.patchValue({
      TripReference: f.TripReference,
      ClientName: f.ClientName,
      AgentName: f.AgentName,
      VendorName: f.VendorName,
      BookedDateFrom: f.BookedDateFrom,
      BookedDateTo: f.BookedDateTo,
      TripStartDateFrom: f.TripStartDateFrom,
      TripStartDateTo: f.TripStartDateTo,
      IsCancelled: f.IsCancelled,
    });
  }

  protected apply(): void {
    const raw = this.form.getRawValue();
    const filters: KtTripFilterModel = {
      TripReference: raw.TripReference,
      ClientName: raw.ClientName,
      AgentName: raw.AgentName,
      VendorName: raw.VendorName,
      BookedDateFrom: raw.BookedDateFrom,
      BookedDateTo: raw.BookedDateTo,
      TripStartDateFrom: raw.TripStartDateFrom,
      TripStartDateTo: raw.TripStartDateTo,
      IsCancelled: raw.IsCancelled,
      ReloadGrid: true,
    };
    this.filterService.setFilters(filters);
    this.close();
  }

  protected reset(): void {
    this.form.reset();
    this.filterService.setFilters({
      TripReference: null,
      ClientName: null,
      AgentName: null,
      VendorName: null,
      BookedDateFrom: null,
      BookedDateTo: null,
      TripStartDateFrom: null,
      TripStartDateTo: null,
      IsCancelled: null,
      ReloadGrid: true,
    });
    this.close();
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
